import {
  ActionCreator,
  ActionCreatorWithPayload,
  ActionCreatorWithoutPayload,
  ActionWithPayload,
  ActionWithoutPayload,
  action$,
} from 'rxbeach';
import { ofType } from 'rxbeach/operators';
import { Subscription } from 'rxjs';

interface SubscribeToAction {
  <T = void>(
    action: ActionCreatorWithPayload<T>,
    handler: (payload: T) => void
  ): Subscription;
  (action: ActionCreatorWithoutPayload, handler: () => void): Subscription;
}

export const subscribeToAction: SubscribeToAction = <T>(
  action: ActionCreator<T>,
  handler: (payload?: T) => void
) =>
  action$
    .pipe(ofType(action))
    .subscribe((action: ActionWithoutPayload | ActionWithPayload<T>) => {
      if ('payload' in action) {
        handler(action.payload);
      } else {
        handler();
      }
    });
